<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    // this.$gtag.event("click", {
    //   event_category: "button",
    //   event_label: "nav buttons",
    //   value: 1,
    // });
  },
  methods: {},
};
</script>

<style lang="less">
</style>
